import { showAlertMessage } from 'javascripts/messages';

function bookmarkDisplayErrorMessage() {
  showAlertMessage(
    'There was a problem displaying this roadmap. Please check that the data and filters are correct. If the problem persists, please contact support@aha.io.'
  );
}

export { bookmarkDisplayErrorMessage };
